// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__r3_3x","label":"SetPasswdForm_label__2d5FG"};